import { render, staticRenderFns } from "./AuxiliaryType.vue?vue&type=template&id=cb5d2bce&scoped=true&"
import script from "./AuxiliaryType.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryType.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryType.vue?vue&type=style&index=0&id=cb5d2bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5d2bce",
  null
  
)

export default component.exports